import { createAction } from '@src/redux/helpers/createAction';
import {
  verifyClaimSaga,
  verifyPaymentInfoSaga,
  verifyCompanyNameSaga,
  validateCodeSaga,
  tinAddressApiSaga,
  generateSecurityKeySaga,
} from './sagas';
import {
  GET_CLAIM,
  VERIFY_PAYMENT_INFO,
  SET_MAIN_RADIO_GROUP,
  SET_IS_PROCEDURE_CODE,
  RESET_STATE,
  VERIFY_COMPANY_NAME,
  VALIDATE_CODE,
  SET_US_MAIL_SECURITY_GROUP,
  TIN_ADDRESS_API,
  GENERATE_SECURITY_KEY,
  SET_INFO_ERROR,
} from './constants';

export const getClaim = (req, onSuccess, onError) => {
  return createAction({
    type: GET_CLAIM,
    cache: false,
    payload: req,
    meta: {
      onSuccess,
      onError,
      async: verifyClaimSaga,
    },
  });
};

export const verifyPaymentInfo = (req, onSuccess, onError) => {
  return createAction({
    type: VERIFY_PAYMENT_INFO,
    cache: false,
    payload: req,
    meta: {
      onSuccess,
      onError,
      async: verifyPaymentInfoSaga,
    },
  });
};

export const setMainRadioGroup = (payload) => {
  return createAction({
    type: SET_MAIN_RADIO_GROUP,
    cache: false,
    payload,
  });
};
export const setValidationErrorType = (payload) => {
  return createAction({
    type: SET_INFO_ERROR,
    cache: false,
    payload,
  });
};
export const setUSMailSecurityRadioGroup = (payload) => {
  return createAction({
    type: SET_US_MAIL_SECURITY_GROUP,
    cache: false,
    payload,
  });
};

export const setReduxIsProcedureCode = (payload) => {
  return createAction({
    type: SET_IS_PROCEDURE_CODE,
    cache: false,
    payload,
  });
};

export const resetState = (payload) => {
  return createAction({
    type: RESET_STATE,
    payload,
  });
};

export const verifyCompanyName = (req, onSuccess, onError) => {
  return createAction({
    type: VERIFY_COMPANY_NAME,
    cache: false,
    payload: req,
    meta: {
      onSuccess,
      onError,
      async: verifyCompanyNameSaga,
    },
  });
};

export const validateCode = (req, onSuccess, onError) => {
  return createAction({
    type: VALIDATE_CODE,
    cache: false,
    payload: req,
    meta: {
      onSuccess,
      onError,
      async: validateCodeSaga,
    },
  });
};

export const tinAddressApi = (req, onSuccess, onError) => {
  return createAction({
    type: TIN_ADDRESS_API,
    cache: false,
    payload: req,
    meta: {
      onSuccess,
      onError,
      async: tinAddressApiSaga,
    },
  });
};

export const generateSecurityKey = (req, onSuccess, onError) => {
  return createAction({
    type: GENERATE_SECURITY_KEY,
    cache: false,
    payload: req,
    meta: {
      onSuccess,
      onError,
      async: generateSecurityKeySaga,
    },
  });
};
